<template>
  <div class="filter-box xsmall">
    <input v-model="value" :placeholder="placeholder" class="xsmall" type="text">
    <div class="label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      value: ''
    };
  },
  props: {
    label: String,
    placeholder: {
      type: String,
      default: 'all'
    }
  },
  methods: {

  },
  computed: {

  },
  watch: {
    value (val) {
      this.$emit('update', val);
    }
  }
};
</script>

<style lang="scss" scoped>
  .filter-box {
    margin-top: 20px;
    width: 25%;
  }
  input {
    font-family: 'Roboto', sans-serif;
    background-color: rgb(224, 224, 224);
    border: none;
    padding: 4px 8px;

    &::placeholder{
      color: gray;
    }
  }

  .label {
    margin-top: 5px;
  }
</style>
